module.exports = __webpack_public_path__ + "static/grocery-store-web-plp-ce2fad54e8338a9de91db90c8358c1f7.png";